import React, { useLayoutEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import DoublePendulAnimation from "../assets/DoublePendulAnimation";

gsap.registerPlugin(ScrollTrigger);

const PendulumBlock = () => {
  const sectionRef = useRef(null);

  useLayoutEffect(() => {
    const st = ScrollTrigger.create({
      trigger: sectionRef.current,
      start: "top top",
      end: "bottom top",
      pin: true,
      pinSpacing: false
    });

    return () => {
      st.kill(true); 
    };
  }, []);

  return (
    <section ref={sectionRef} className="pendulum-block">
      <div className="pendulum-block__bg">
        <DoublePendulAnimation />
      </div>
    </section>
  );
};

export default PendulumBlock;
